import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { authenticationGuard } from '@guards/authentication.guard';
import { PageNotFoundComponent } from '@shared/page-not-found/page-not-found.component';
import { LogoutComponent } from './logout/logout.component';
import { BrandedSiteDownComponent } from './site-down/branded-site-down/branded-site-down.component';

const routes: Routes = [
  { path: 'logout', component: LogoutComponent },
  { path: 'site-error', component: BrandedSiteDownComponent },
  {
    path: '',
    canActivate: [authenticationGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('./root/root.module').then(m => m.RootModule),
  },
  { path: '**', component: PageNotFoundComponent, canActivate: [authenticationGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
